import Container from 'react-bootstrap/Container'
import ButtonLink from '../../../Buttons/ButtonLink/ButtonLink'
import './FooterLinks.scss'

const WEB_PORTAL_URL = process.env.REACT_APP_WEB_PORTAL_URL

const LINKS_1 = [
    { url: 'vase-multikino', text: 'Vaše multikino' },
    { url: 'program', text: 'Program' },
    { url: 'filmy', text: 'Filmy' },
    { url: 'akce', text: 'Akce' },
    { url: 'kontakty', text: 'Kontakty' },
]

const LINKS_2 = [
    { url: 'cenik', text: 'Ceník' },
    { url: 'gold-class', text: 'GOLD CLASS' },
    { url: 'theatre-deluxe', text: 'THEATRE DELUXE' },
    { url: 'obcerstveni', text: 'Občerstvení' },
    { url: 'darkove-poukazy', text: 'Dárkové poukázky' },
    { url: 'blog', text: 'Blog' },
]

const LINKS_3 = [
    { url: 'https://cinestar.cz/cz/hradec/technologie-salu', text: 'Technologie sálů' },
    { url: 'https://firmy.cinestar.cz/cs/', text: 'Pro firmy' },
    { url: 'https://cinestar.cz/cz/hradec/pro-skoly', text: 'Pro školy' },
    { url: 'https://firmy.cinestar.cz/cs/pronajem-salu', text: 'Pronájmy sálů' },
    { url: 'https://firmy.cinestar.cz/cs/kinoreklama', text: 'Kinoreklama' },
    { url: 'https://www.kinolidi.cz/', text: 'Kariéra' },
]

const FooterLinks = () => {
    const redirect = (path) => {
        window.location.href = `${WEB_PORTAL_URL}${path}`
    }
    return (
        <Container fluid className={'footer-links d-flex gap-5'}>
            <div className={'footer-links--top d-flex'}>
                {LINKS_1.map((link, index) => (
                    <ButtonLink key={index} className="text-nowrap" onClick={() => redirect(link.url)}>
                        {link.text}
                    </ButtonLink>
                ))}
            </div>
            <Container fluid className="d-flex gap-5">
                <div className="footer-links--bottom d-flex flex-column">
                    {LINKS_2.map((link, index) => (
                        <ButtonLink key={index} className="text-nowrap" onClick={() => redirect(link.url)}>
                            {link.text}
                        </ButtonLink>
                    ))}
                </div>
                <div className="footer-links--bottom d-flex flex-column">
                    {LINKS_3.map((link, index) => (
                        <ButtonLink
                            key={index}
                            className="text-nowrap"
                            onClick={() => (window.location.href = link.url)}
                        >
                            {link.text}
                        </ButtonLink>
                    ))}
                </div>
            </Container>
        </Container>
    )
}

export default FooterLinks
